import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ui-components" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "UiComponentsPage", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "ui-components__items" }
const _hoisted_5 = { class: "control-m" }
const _hoisted_6 = { style: {"height":"40px"} }
const _hoisted_7 = {
  class: "control-2xs",
  style: {"margin-bottom":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentsData, (group) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: group.name
        }, [
          _hoisted_3,
          _createElementVNode("h2", null, _toDisplayString(group.name), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (componentData, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "ui-components__item-view"
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(componentData.name), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getLayoutClass(componentData.layout))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.propConfigs, (props, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "ui-components__configured-item"
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getPropsDescription(props)), 1)
                      ]),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(componentData.component), _normalizeProps(_guardReactiveProps(_ctx.applyProps(componentData.props, props))), null, 16))
                    ]))
                  }), 128))
                ], 2)
              ]))
            }), 128))
          ])
        ], 64))
      }), 128))
    ])
  ]))
}